"use client";
import {
  __spreadProps,
  __spreadValues
} from "../../../../chunk-3GWWZKX7.js";
import React from "react";
const setRef = (ref, value) => {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref != null) {
    ref.current = value;
  }
};
const mergeRefs = (...refs) => {
  return (value) => {
    refs.forEach((ref) => {
      setRef(ref, value);
    });
  };
};
const createForwardRef = (ReactComponent, displayName) => {
  const forwardRef = (props, ref) => {
    return /* @__PURE__ */ React.createElement(ReactComponent, __spreadProps(__spreadValues({}, props), { forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  return React.forwardRef(forwardRef);
};
const defineCustomElement = (tagName, customElement) => {
  if (customElement !== void 0 && typeof customElements !== "undefined" && !customElements.get(tagName)) {
    customElements.define(tagName, customElement);
  }
};
export * from "./attachProps.js";
export * from "./case.js";
export {
  createForwardRef,
  defineCustomElement,
  mergeRefs,
  setRef
};
